export default "__VITE_ASSET__fe3206a6__"